import React, { useState, useEffect } from "react";
import styles from "./Dashboard.module.css";
import {BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer} from "recharts";
import { PieChart, Pie, Tooltip as PieTooltip, Legend, Cell} from "recharts";

export const Dashboard = () => {

    const [updateTime, setUpdateTime] = useState<string>("");

    useEffect(() => {

        const updateDateTime = () => {
            const now = new Date();
            const day = String(now.getDate()).padStart(2, "0");
            const month = String(now.getMonth() + 1).padStart(2, "0");
            const year = now.getFullYear();
            const hours = String(now.getHours()).padStart(2, "0");
            const minutes = String(now.getMinutes()).padStart(2, "0");
            setUpdateTime(`${day}.${month}.${year} ${hours}:${minutes}`);
        };

        updateDateTime();

        const intervalId = setInterval(updateDateTime, 60000);

        return () => clearInterval(intervalId);
    }, []);

    const barData = [
        { name: "Пн", "План": 70, "Факт": 60 },
        { name: "Вт", "План": 90, "Факт": 80 },
        { name: "Ср", "План": 60, "Факт": 45 },
        { name: "Чт", "План": 95, "Факт": 90 },
        { name: "Пт", "План": 85, "Факт": 70 },
    ];

    const statusData = [
        { name: "В норме", value: 5 },
        { name: "Внимание", value: 3 },
        { name: "Критично", value: 2 },
    ];

    const todayPlan = 60;
    const todayFact = 30;
    const progressPercent = Math.min(
        Math.round((todayFact / todayPlan) * 100),
        100
    );

    const COLORS = {
        "В норме": "#0E8F4B",
        "Внимание": "#FFA500",
        "Критично": "#E53935"
    };

    return (
        <div className={styles.dashboard}>

            <header className={styles.header}>
                <div >
                <h1 className={styles.title}>Оперативная сводка</h1>
                <p className={styles.subtitle}>Ситуация по г. Улан-Удэ и Иволгинскому району</p>
                </div>
                <div className={styles.updateTime}>
                    Обновлено: {updateTime}
                </div>
            </header>

            <div className={styles.statsGrid}>

                <div className={styles.statCard}>
                    <div className={styles.statContent}>
                        <h3 className={styles.statLabel}>Всего площадок</h3>
                        <p className={styles.statValue}>6</p>
                        <span className={styles.statChange}>+2 новые за неделю</span>
                    </div>
                </div>

                <div className={styles.statCard}>
                    <div className={styles.statContent}>
                        <h3 className={styles.statLabel}>Вывезено сегодня</h3>
                        <p className={styles.statValue}>{todayFact} м³</p>

                        <div className={styles.progressBar}>
                            <div
                                className={styles.progressFill}
                                style={{ width: `${progressPercent}%` }}
                            />
                        </div>

                    </div>
                </div>

                <div className={styles.statCard}>
                    <div className={styles.statContent}>
                        <h3 className={styles.statLabel}>На линии ТС</h3>
                        <p className={styles.statValue}>
                            2<span className={styles.total}>/3</span>
                        </p>
                    </div>
                </div>

                <div className={`${styles.statCard} ${styles.incidentCard}`}>
                    <div className={styles.statContent}>
                        <h3 className={styles.statLabel}>Инциденты</h3>
                        <p className={styles.statValue}>2</p>
                        <span className={styles.statChange}>Требуют внимания</span>
                    </div>
                </div>

            </div>

            <div className={styles.contentGrid}>

                <div className={styles.chartCard}>
                    <div className={styles.cardHeader}>
                        <h2 className={styles.cardTitle}>План / факт вывоза (м³)</h2>
                    </div>

                    <div className={styles.chartWrapper}>
                        <ResponsiveContainer width="100%" height="100%">
                            <BarChart data={barData}>
                                <CartesianGrid strokeDasharray="3 3" />
                                <XAxis dataKey="name" />
                                <YAxis />
                                <Tooltip />
                                <Bar dataKey="Факт" fill="#A0AEC0" />
                                <Bar dataKey="План" fill="#48BB78" />
                            </BarChart>
                        </ResponsiveContainer>
                    </div>
                </div>

                <div className={styles.pieCard}>
                    <div className={styles.cardHeader}>
                        <h2 className={styles.cardTitle}>Статус контейнерных площадок</h2>
                    </div>

                    <div className={styles.pieChartWrapper}>
                        <ResponsiveContainer width="100%" height="100%">
                            <PieChart>
                                <Pie
                                    data={statusData}
                                    dataKey="value"
                                    nameKey="name"
                                    innerRadius={70}
                                    outerRadius={100}
                                    paddingAngle={5}
                                    label={false}
                                    labelLine={false}
                                >
                                    {statusData.map((entry, index) => (
                                        <Cell key={index} fill={COLORS[entry.name]} />
                                    ))}
                                </Pie>

                                <PieTooltip formatter={(v: number) => `${v} шт.`} />

                                <Legend
                                    verticalAlign="bottom"
                                    align="center"
                                    iconType="circle"
                                    formatter={(value: string, entry: any) => {
                                        const item = statusData.find((s) => s.name === value);
                                        return `${value} (${item?.value ?? 0})`;
                                    }}
                                />
                            </PieChart>
                        </ResponsiveContainer>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Dashboard;